import React, { Component } from 'react'
import AppPopover from '../UIComponents/ModalShell/AppPopover'
import store from '../../redux/store'
import PropTypes from 'prop-types'
import Button from './Button'
import RecurrenceModal from '../UIComponents/FloatModals/RecurrenceModal'
import { translate } from '../../i18n/TranslationService'
import { getRecurrenceInfo } from '../TaskListView/Utils/TasksHelper'
import { createFloatPopupLock } from '../../hooks/useFloatPopupLock'

class RecurrenceButton extends Component {
    constructor(props) {
        super(props)
        const storeState = store.getState()
        this.popupLock = createFloatPopupLock(store.dispatch)

        this.state = {
            visiblePopover: false,
            smallScreen: storeState.smallScreen,
            unsubscribe: store.subscribe(this.updateState),
        }
    }

    componentWillUnmount() {
        this.popupLock.release()
        this.state.unsubscribe()
    }

    updateState = () => {
        const storeState = store.getState()

        this.setState({
            smallScreen: storeState.smallScreen,
        })
    }

    hidePopover = recurrence => {
        this.setState({ visiblePopover: false })
        this.popupLock.release()

        if (this.props.onChangeValue !== undefined && recurrence) {
            this.props.onChangeValue(recurrence)
        }
    }

    showPopover = () => {
        this.setState({ visiblePopover: true })
        this.popupLock.acquire()
    }

    render() {
        const { task, projectId, disabled, style, inEditTask } = this.props
        const { visiblePopover, smallScreen } = this.state

        const recurrenceInfo = getRecurrenceInfo(task.recurrence)

        return (
            <AppPopover
                content={<RecurrenceModal task={task} projectId={projectId} closePopover={this.hidePopover} />}
                onClickOutside={this.hidePopover}
                isOpen={visiblePopover}
                position={['bottom', 'left', 'right', 'top']}
                padding={4}
                align={'end'}
                contentLocation={smallScreen ? null : undefined}
            >
                <Button
                    title={
                        inEditTask && smallScreen
                            ? null
                            : translate(recurrenceInfo.large, recurrenceInfo.interpolations)
                    }
                    type={'ghost'}
                    noBorder={inEditTask && smallScreen}
                    icon={'rotate-cw'}
                    buttonStyle={style}
                    onPress={this.showPopover}
                    disabled={disabled}
                />
            </AppPopover>
        )
    }
}

RecurrenceButton.propTypes = {
    task: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    style: PropTypes.object,
    inEditTask: PropTypes.bool,
    onChangeValue: PropTypes.func,
}

RecurrenceButton.defaultProps = {
    inEditTask: false,
}

export default RecurrenceButton
